import React from 'react';

import {AttendanceStatus} from '../schema';

import IconRegistered from '../components/icon/IconRegistered';
import IconCancelled from '../components/icon/IconCancelled';
import IconStudent from '../components/icon/IconStudent';
import IconTransfer from '../components/icon/IconTransfer';

type Props = {
  status: AttendanceStatus
  className?: string
}

export default function AttendeeRegistrationStatus({ status, className }: Props) {

  switch (status) {
    case AttendanceStatus.REGISTERED:
      return ( <div className={className}><IconRegistered className="text-gray-dark"/> Registered</div> );
    case AttendanceStatus.CANCELLED:
      return ( <div className={className}><IconCancelled className="text-gray-dark"/> Cancelled</div> );
    case AttendanceStatus.PARTICIPATED:
      return ( <div className={className}><IconStudent className="text-gray-dark"/> Participated</div> );
    case AttendanceStatus.TRANSFERRED:
      return ( <div className={className}><IconTransfer className="text-gray-dark"/> Transferred</div> );
    default:
      return ( <div className={className}>Unknown</div> );
  }
}
